import React, { useState, useEffect, useRef } from "react";
import { socket } from "../../io";
import "./Line.css";
import { Modal } from "react-bootstrap";
import { headers, url } from "../../utils/const";
import { handleGetAmountBet, handleGetBet } from "../../utils/handle-bet";
import Result from "../results/Result";
import imageUrl from "../../assets/players/generic.jpg";
import Hour from "../generic/hour";
import Footer from "../generic/footer";
import mlbLogo from "../../assets/logo-vlb.png";
import nameMlb from "../../assets/name-vlb.png";
import urlAudio from "../../assets/sounds/homerun.mp3";
import vozHr from "../../assets/sounds/Voz-hr.mp3";
import changeVoz from "../../assets/sounds/change.mp3";
import playVoz from "../../assets/sounds/playball.mp3";
import hrGoing from "../../assets/sounds/hr-going.mp3";
import tambores from "../../assets/sounds/tambores.mp3";
import exclamation from "../../assets/sounds/exclamation.mp3";
import { GetProgram } from "../../utils/get-programs";
import Publish from "../generic/publicity";

let playing = false;
function Lines(number) {
  const audioRef = useRef(null);
  const vozHrRef = useRef(null);
  const playRef = useRef(null);
  const changeRef = useRef(null);
  const vozHomeRunRef = useRef(null);
  const tamboresRef = useRef(null);
  const exclamationRef = useRef(null);
  const amountBetRef = useRef(50)
  const [games, setGames] = useState([]);
  const [results, setResult] = useState([]);
  const [jpg, setJpg] = useState();
  const [jpl, setJpl] = useState();
  const [jpc, setJpc] = useState();
  const [lastWinerJpGral, setLastWinerJpGral] = useState();
  const [showModalTicket, setShowModalTicket] = useState(false);
  const [show, setShow] = useState(false) // para mostrar el modal al dar click a un juego
  const [hr, setHr] = useState(true);
  const [sound, setSound] = useState(urlAudio);
  const [gameSelected, setGameSelected] = useState();
  const [programs, setPrograms] = useState([])
  const [credit, setCredit] = useState(500);
  const [baseNum, setBaseNum] = useState(""); // "01".."30"
  const [betted, setBetted] = useState([]);   // + - k S R P (en cualquier combinación)
  const [stake, setStake] = useState(1);
  const [amountWin, setAmountWin] = useState([]);
  const [inputAmoutBetted, setInputAmoutBetted] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [plays, setPlays] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (localStorage.getItem('level') === '5') GetPlayer()
  }, [])
  useEffect(() => {
    const handleResults = (data) => {
      setResult(data);
    };
    const handleJackpot = (data) => {
      setJpc(data)
    }
    socket.on("results", handleResults);
    socket.on('jpc-from-server', handleJackpot)

    return () => {
      socket.off("results", handleResults); // Limpieza
      socket.off('jpc-from-server', handleJackpot)
    };
  }, []);

  useEffect(() => {
    const handleGames = (data) => {
      console.log("Games from server:", data);
      if (audioRef.current) audioRef.current.muted = false;
      if (vozHrRef.current) vozHrRef.current.muted = false;
      if (changeRef.current) changeRef.current.muted = false;
      if (playRef.current) playRef.current.muted = false;
      if (vozHomeRunRef.current) vozHomeRunRef.current.muted = false;
      if (exclamationRef.current) exclamationRef.current.muted = false;
      if (tamboresRef.current) tamboresRef.current.muted = false;
      /**Crear el programa */
      if (data && data.games) setPrograms(() => GetProgram(data.games))
      if (data.games?.some((item) => item.result === "HR" && !item.gameOver) && vozHrRef.current) {
        vozHrRef.current.play().catch((err) => {
          console.warn("Reproducción bloqueada o fallida:", err);
        });
        audioRef.current.play().catch((err) => {
          console.warn("Reproducción bloqueada o fallida:", err);
        });
        // setTimeout(()=>
        // exclamationRef.current.play().catch((err)=>{
        //   console.warn("Reproducción bloqueada o fallida:", err);
        // }),4000)
      }
      // if ((data.games?.some((item) => item.result === "3B" && !item.gameOver)||data.games?.some((item) => item.result === "2B" && !item.gameOver)||data.games?.some((item) => item.result === "Hc" && !item.gameOver)) && audioRef.current) {

      //   audioRef.current.play().catch((err) => {
      //     console.warn("Reproducción bloqueada o fallida:", err);
      //   });
      // setTimeout(()=>
      // exclamationRef.current.play().catch((err)=>{
      //   console.warn("Reproducción bloqueada o fallida:", err);
      // }),2000)
      // }
      const bases = data.games.some(item => item.bases.filter(b => b == true).length >= 3)
      if ((bases) && tamboresRef.current) {
        changeRef.current.play().catch((err) => {
          console.warn("Reproducción bloqueada o fallida:", err);
        });
      }
      if ((data.games?.some((item) => item.result === "Change" && !item.gameOver)) && changeRef.current) {
        changeRef.current.play().catch((err) => {
          console.warn("Reproducción bloqueada o fallida:", err);
        });
      }
      if (data.active == false && show == true) {
        setBetted([])
        setShow(false)
      };
      if (data.active == true) {
        playing = true
        socket.emit('jpc')
      };
      if (data.active == false && data.active !== playing && playRef.current) {
        playing = false;
        playRef.current.play().catch((err) => {
          console.warn("Reproducción bloqueada o fallida:", err);
        });
      }
      setTimeout(() => {
        setGames(data);
        // if (data.games?.some((item) => item.result === "HR" && !item.gameOver) && vozHomeRunRef.current) {
        // vozHomeRunRef.current.play().catch((err) => {
        //   console.warn("Reproducción bloqueada o fallida:", err);
        // });
        // }
      }, 3000);
    };
    socket.on("games-line", handleGames);

    return () => {
      socket.off("games-line", handleGames); // Limpieza
    };
  }, [sound, show]);

  useEffect(() => {
    const handleScreen = (data) => {
      if (number.screen === 3) {
        if (results) setResult(false);
        if (localStorage.getItem("reload") === "false") {
          localStorage.setItem("reload", "true");
          window.location.reload();
        }
      } else {
        if (!results) setResult(true);
        if (localStorage.getItem("reload") === "true") localStorage.setItem("reload", "false");
      }

      if (data && data.jpg && jpg !== data.jpg.value) {
        // setJpg(data.jpg.value || "");
        //  setLastWinerJpGral(data.jpg);
        // if (!jpl) {
        //   socket.emit("jpl", "");
        //   socket.on("jpl-from-server", (jp) => setJpl(jp));
        // }
        if (!jpc) {
          socket.emit("jpc");
          socket.on("jpc-from-server", (jp) => setJpc(jp));
        }
      }

      if (data.time) {
        // setTime(data.time);
      }
    };

    socket.on("screen", handleScreen);

    return () => {
      socket.off("screen", handleScreen);
    };
  }, [jpc, jpl, jpg, lastWinerJpGral, number]);
  const splitSecondCapital = (str) => {
    return str?.replace(/^([A-ZÁÉÍÓÚÜa-záéíóúü])[a-záéíóúü]*([A-ZÁÉÍÓÚÜ].*)$/, "$1 $2");
  };
  const formatStat = (value, decimals = 0) => {
    if (value === null || value === undefined || value === "") return "-";

    const number = Number(value);

    if (Number.isNaN(number)) return value;

    return decimals > 0 ? number.toFixed(decimals) : number;
  };

  const getTeamRecord = (team) => {
    const wins = team?.static?.wins ?? team?.wins ?? "-";
    const loses =
      team?.static?.lose ??
      team?.static?.loses ??
      team?.lose ??
      team?.loses ??
      "-";

    return `${wins}-${loses}`;
  };

  const getPitcherStat = (pitcher, key) => {
    return pitcher?.[key] ?? pitcher?.static?.[key];
  };
  const firstDefined = (...values) =>
    values.find((value) => value !== undefined && value !== null && value !== "");

  const formatRate = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const number = Number(value);

    if (Number.isNaN(number)) return value;

    return number.toFixed(3).replace(/^0/, "");
  };
const formatIpBaseball = (value, outs) => {
  if (outs !== undefined && outs !== null && outs !== "") {
    const totalOuts = Number(outs);

    if (!Number.isNaN(totalOuts)) {
      const innings = Math.floor(totalOuts / 3);
      const partialOuts = totalOuts % 3;
      return `${innings}.${partialOuts}`;
    }
  }

  if (value === null || value === undefined || value === "") return "-";

  const number = Number(value);

  if (Number.isNaN(number)) return value;

  const innings = Math.trunc(number);
  const decimalText = String(value).split(".")[1];

  if (decimalText === "1" || decimalText === "2") {
    return `${innings}.${decimalText}`;
  }

  return number.toFixed(1);
};

const formatAvg = (value) => {
  if (value === null || value === undefined || value === "") return "-";

  const number = Number(value);

  if (Number.isNaN(number)) return value;

  return number.toFixed(3).replace(/^0/, "");
};

const toNum = (value) => {
  const number = Number(value);
  return Number.isNaN(number) ? 0 : number;
};

const getGameLineValue = (line, ...keys) => {
  for (const key of keys) {
    if (line?.[key] !== undefined && line?.[key] !== null && line?.[key] !== "") {
      return line[key];
    }
  }

  return 0;
};
  const getCurrentPitcherSide = (game) =>
    game.batting === "home" ? "away" : "home";

  const getCurrentPitcher = (game) =>
    game.picher?.[getCurrentPitcherSide(game)];

  const getCurrentBatter = (game) => {
    const side = game.batting;
    const index = Math.max((game.bat?.[side] ?? 1) - 1, 0);

    return game.linup?.[side]?.[index];
  };

const getPitcherGameStats = (game, side, pitcher = null) => {
  const line =
    pitcher?.gameStats ??
    game?.picher?.[side]?.gameStats ??
    game?.starterPichingLine?.[side] ??
    game?.pichingLine?.[side] ??
    game?.pitchingLine?.[side] ??
    game?.pitcherLine?.[side] ??
    {};

  return [
    {
      label: "IP",
      value: formatIpBaseball(
        firstDefined(line?.ip, line?.inningsPitched),
        firstDefined(line?.outs, line?.outsPitched)
      ),
    },
    {
      label: "H",
      value: formatStat(firstDefined(line?.h, line?.hits)),
    },
    {
      label: "ER",
      value: formatStat(firstDefined(line?.er, line?.earnedRuns)),
    },
    {
      label: "BB",
      value: formatStat(firstDefined(line?.bb, line?.walks)),
    },
    {
      label: "K",
      value: formatStat(
        firstDefined(line?.k, line?.so, line?.strikeouts, game?.k?.[side])
      ),
    },
  ];
};

const getLivePitcherStats = (game) => {
  const side = getCurrentPitcherSide(game);
  const pitcher = getCurrentPitcher(game);

  return getPitcherGameStats(game, side, pitcher);
};
const getBatterPanelData = (batter) => {
  const gameLine =
    batter?.gameStats ??
    batter?.today ??
    batter?.gameLine ??
    batter?.line ??
    {};

  const season = batter?.static ?? batter ?? {};

  const ab = toNum(firstDefined(gameLine?.ab, gameLine?.atBats, batter?.abGame));
  const hits = toNum(firstDefined(gameLine?.h, gameLine?.hits, batter?.hGame));

  const doubles = toNum(
    firstDefined(
      gameLine?.doubles,
      gameLine?.double,
      gameLine?.twoB,
      batter?.doublesGame
    )
  );

  const triples = toNum(
    firstDefined(
      gameLine?.triples,
      gameLine?.triple,
      gameLine?.threeB,
      batter?.triplesGame
    )
  );

  const hr = toNum(firstDefined(gameLine?.hr, gameLine?.homeRuns, batter?.hrGame));
  const bb = toNum(firstDefined(gameLine?.bb, gameLine?.walks, batter?.bbGame));
  const runs = toNum(firstDefined(gameLine?.runs, gameLine?.r, batter?.runsGame));
  const rbi = toNum(firstDefined(gameLine?.rbi, batter?.rbiGame));
  const so = toNum(firstDefined(gameLine?.so, gameLine?.k, gameLine?.strikeouts, batter?.soGame));

  const avg = formatAvg(firstDefined(season?.avg, batter?.avg));
  const ops = formatAvg(firstDefined(season?.ops, batter?.ops));

  const pa = toNum(
    firstDefined(
      gameLine?.pa,
      gameLine?.plateAppearances,
      ab + bb + toNum(gameLine?.hp)
    )
  );

  const hasTurn = pa > 0 || ab > 0 || hits > 0 || bb > 0 || runs > 0 || rbi > 0 || so > 0;

  const todayParts = [];

  if (hasTurn) {
    todayParts.push(`${ab}-${hits}`);

    if (doubles > 0) todayParts.push(doubles > 1 ? `${doubles} DB` : "DB");
    if (triples > 0) todayParts.push(triples > 1 ? `${triples} TB` : "TB");
    if (hr > 0) todayParts.push(hr > 1 ? `${hr} HR` : "HR");
    if (bb > 0) todayParts.push(bb > 1 ? `${bb} BB` : "BB");
    // if (runs > 0) todayParts.push(`${runs}R`);
    if (rbi > 0) todayParts.push(rbi > 1 ? `${rbi}RBI` : "RBI");
    if (so > 0) todayParts.push(so > 1 ? `${so}K` : "K");
  } else {
    todayParts.push("0-0");
  }

  const seasonHits = toNum(firstDefined(season?.h, season?.hits, batter?.hits));
  const seasonDoubles = toNum(firstDefined(season?.doubles, season?.double, season?.twoB, batter?.doubles));
  const seasonTriples = toNum(firstDefined(season?.triples, season?.triple, season?.threeB, batter?.triples));
  const seasonBB = toNum(firstDefined(season?.bb, season?.walks, batter?.bb));
  const seasonSO = toNum(firstDefined(season?.so, season?.k, season?.strikeouts, batter?.so));
  const seasonHR = toNum(firstDefined(season?.hr, season?.homeRuns, batter?.hr));
  const seasonRBI = toNum(firstDefined(season?.rbi, batter?.rbi));
  const seasonRuns = toNum(firstDefined(season?.runs, season?.r, batter?.runs));

  const seasonParts = [];

  if (seasonHits > 100) seasonParts.push(`${seasonHits}H`);
  if (seasonDoubles > 25) seasonParts.push(`${seasonDoubles}DB`);
  if (seasonTriples > 10) seasonParts.push(`${seasonTriples}TB`);
  if (seasonBB > 50) seasonParts.push(`${seasonBB}BB`);
  if (seasonSO > 50) seasonParts.push(`${seasonSO}K`);
  if (seasonHR > 0) seasonParts.push(`${seasonHR}HR`);
  if (seasonRBI > 50) seasonParts.push(`${seasonRBI}RBI`);
  if (seasonRuns > 50) seasonParts.push(`${seasonRuns}R`);

  if (avg !== "-") seasonParts.push(`AVG ${avg}`);
  // if (ops !== "-") seasonParts.push(`OPS ${ops}`);

  return {
    todaySummary: todayParts.join(" "),
    seasonSummary: seasonParts.length > 0 ? seasonParts.join(" ") : `AVG ${avg} OPS ${ops}`,
  };
};

  const renderLivePlayers = (game) => {
    const currentPitcher = getCurrentPitcher(game);
    const currentBatter = getCurrentBatter(game);
    const pitcherStats = getLivePitcherStats(game);
    const batterPanel = getBatterPanelData(currentBatter);

    return (
      <div className="live-players-panel">
        <div className="live-player-card live-pitcher-card">
          <img
            className="live-player-photo"
            src={currentPitcher?.img || imageUrl}
            alt={currentPitcher?.name || "Pitcher"}
          />

          <div className="live-player-content">
            <div className="live-player-role-row">
              <span className="live-player-role">Pitcher</span>
            </div>

            <div className="live-player-name-row">
              <span className="live-player-name">
                {splitSecondCapital(currentPitcher?.name?.replace(/ /g, ""))}
              </span>

              <span className="live-inline-note">
                ({game.k?.[game.piching] ?? 0}K)
              </span>
            </div>

            {/* <div className="live-stat-caption">Hoy</div> */}

            <div className="live-stat-grid live-stat-grid-5">
              {pitcherStats.map((stat) => (
                <div className="live-stat-box" key={stat.label}>
                  <span><strong>{stat.value}</strong> {stat.label}</span>
                  
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="live-player-divider"></div>

        <div className="live-player-card live-batter-card">
          <img
            className="live-player-photo"
            src={currentBatter?.img || imageUrl}
            alt={currentBatter?.name || "Batter"}
          />

          <div className="live-player-content">
            <div className="live-player-role-row">
              <span className="live-player-role">Batter</span>
            </div>

            <div className="live-player-name-row">
              <span className="live-player-name">
                {splitSecondCapital(currentBatter?.name?.replace(/ /g, ""))}
              </span>
            </div>

            {/* <div className="live-stat-caption">{batterPanel.title}</div> */}
<div className="live-batter-summary-split">
  <span className="live-batter-today">
    {batterPanel.todaySummary}
  </span>

  <div className="live-batter-separator">|</div>

  <span className="live-batter-season">
    {batterPanel.seasonSummary}
  </span>
</div>
          </div>
        </div>
      </div>
    );
  };
  const renderFinalPitchers = (game) => {
  const awayPitcher = game.picher?.away;
  const homePitcher = game.picher?.home;

  const awayStats = getPitcherGameStats(game, "away");
  const homeStats = getPitcherGameStats(game, "home");

  return (
    <div className="live-players-panel live-final-panel">
      <div className="live-player-card live-pitcher-card">
        <img
          className="live-player-photo"
          src={awayPitcher?.img || imageUrl}
          alt={awayPitcher?.name || "Pitcher Away"}
        />

        <div className="live-player-content">
          <div className="live-player-role-row">
            <span className="live-player-role">Pitcher</span>
          </div>

          <div className="live-player-name-row">
            <span className="live-player-name">
              {splitSecondCapital(awayPitcher?.name?.replace(/ /g, ""))}
            </span>

            <span className="live-inline-note">
              ({game.k?.away ?? 0}K)
            </span>
          </div>

          {/* <div className="live-stat-caption">Juego</div> */}

          <div className="live-stat-grid live-stat-grid-5">
            {awayStats.map((stat) => (
              <div className="live-stat-box" key={stat.label}>
                <span>{stat.label}</span>
                <strong>{stat.value}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="live-player-divider"></div>

      <div className="live-player-card live-pitcher-card">
        <img
          className="live-player-photo"
          src={homePitcher?.img || imageUrl}
          alt={homePitcher?.name || "Pitcher Home"}
        />

        <div className="live-player-content">
          <div className="live-player-role-row">
            <span className="live-player-role">Pitcher</span>
          </div>

          <div className="live-player-name-row">
            <span className="live-player-name">
              {splitSecondCapital(homePitcher?.name?.replace(/ /g, ""))}
            </span>

            <span className="live-inline-note">
              ({game.k?.home ?? 0}K)
            </span>
          </div>

          {/* <div className="live-stat-caption">Juego</div> */}

          <div className="live-stat-grid live-stat-grid-5">
            {homeStats.map((stat) => (
              <div className="live-stat-box" key={stat.label}>
                <span>{stat.label}</span>
                <strong>{stat.value}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
  const GetPlayer = async () => {
    const res = await fetch(`${url}/player/info-player`, { method: 'get', headers: headers, credentials: 'include' });
    const data = await res.json();
    setTickets(() => data.ticket);
    setCredit(() => data.player.credit.balance)

  }

  /**Seleccciona el juego y abre modal */
  const SelectGame = (thisGame) => {
    console.log('This Progrea', programs.find(item => item.idGame == thisGame.idGame))
    setGameSelected(thisGame)
    setShow(value => localStorage.getItem("level") == "5" ? !value : false)
  }
  /**Noramlizar */
  function normalizeBase(v) {
    // Solo números, 1..30, y con 2 dígitos
    const only = v.replace(/\D/g, "");
    if (!only) return "";
    let n = parseInt(only, 10);
    if (isNaN(n)) return "";
    if (n < 1) n = 1;
    if (n > 30) n = 30;
    return n.toString().padStart(2, "0");
  }
  function addPlay() {
    if (!baseNum) return;
    const st = Number(stake) || 0;
    if (st <= 0) return;
    const code = '0121';
    setPlays((prev) => [...prev, { code, stake: st }]);
    setBaseNum("");
    setStake(1);
  }

  function removePlay(idx) {
    setPlays((prev) => prev.filter((_, i) => i !== idx));
  }

  function clearAll() {
    setPlays([]);
    setBaseNum("");
    setStake(1);
  }
  /**Retirar una jugada */
  const Retirar = (index) => {
    betted.splice(index, 1);
    handleGetAmountWin(amountBetRef.current.value || 0)
  };
  //Cancelar Jugada Actual
  const CancelarThisBet = () => {
    setBetted([]);
  };
  const handleGetAmountWin = (amoutThisTicket) => {
    setAmountWin(betted.reduce((acum, current) => acum * (1 + (current.rate < 0 ? (-1 * 10) / current.rate : current.rate / 10)), amoutThisTicket));
  };
  const CreateTicket = async () => {
    const ticketCreated = await handleGetAmountBet(amountBetRef.current.value, amountWin, betted, games.num)
    if (ticketCreated.toLocaleLowerCase('creado')) {
      setBetted([])
      setShow(false)
      await GetPlayer()
      alert(ticketCreated)
    }
  }
  return (
    <div className="main-layout">
<div className="header">
  <div className="header-brand">
    <div
      className="header-brand-box"
      onClick={() =>
        localStorage.getItem("level") === "5"
          ? (window.location.href = "/admin-player")
          : (window.location.href = "/bet")
      }
      onTouchStart={() =>
        localStorage.getItem("level") === "5"
          ? (window.location.href = "/admin-player")
          : (window.location.href = "/bet")
      }
    >
      <img src={mlbLogo} alt="Logo" className="header-brand-logo" />
      <div className="header-brand-copy">
        <span className="header-brand-top">VIRTUAL LEAGUE</span>
        <span className="header-brand-bottom">BASEBALL</span>
      </div>
    </div>
  </div>

  <div className="header-jackpot">
    <span className="header-jackpot-label">JACKPOT</span>
    <span className="header-jackpot-value">
      {jpc ? jpc.value.toLocaleString("en-EN") : "0"}
    </span>
  </div>

  <div className="header-title-box">
    <span className="header-title-main">
      {games.active ? "PRÓXIMO EVENTO" : "EVENTO EN PROCESO"} No.
    </span>
    <span className="header-title-number">
      {games.num?.toString().padStart(4, "0")}
    </span>
  </div>

  <div className="header-status-box">
    <Hour num={games.num} active={games.active} />
  </div>
</div>
      <div className={games.active ? "body-line" : "body"}>
        <audio src={urlAudio} ref={audioRef} preload="auto" muted />
        <audio src={hrGoing} ref={vozHrRef} preload="auto" muted />
        <audio src={changeVoz} ref={changeRef} preload="auto" muted />
        <audio src={playVoz} ref={playRef} preload="auto" muted />
        <audio src={vozHr} ref={vozHomeRunRef} preload="auto" muted />
        <audio src={tambores} ref={tamboresRef} preload="auto" muted />
        <audio src={exclamation} ref={exclamationRef} preload="auto" muted />
        {games && games.active === true && games.games ? (
          <>
            {games.games.map((game) => (
              <div
                className="m-0 p-0 line-card"
                key={game.idGame || game.id}
                onClick={() => SelectGame(game)}
              >
                <div className="line-card-header">
                  <div>#</div>
                  <div>TEAM</div>
                  <div>JC</div>
                  <div>R</div>
                  <div>RL</div>
                  <div>P</div>
                  <div>SL</div>
                  <div>KS</div>
                </div>

                <div className="line-card-row">
                  <div className="line-team-number">{game.away.code}</div>

                  <div className="line-team-cell">
                    <img src={game.away.logo} alt={game.away.symbol} />

                    <div className="line-team-copy">
                      <span className="line-team-symbol">{game.away.symbol}</span>
                      <span className="line-team-record">{getTeamRecord(game.away)}</span>
                    </div>
                  </div>

                  <div>{game.line.jc.away}</div>
                  <div>+{game.line.jc.runs}</div>

                  <div>
                    <span className="line-spread-label">
                      {game.line.rl.away.da ? "(-1.5)" : "(+1.5)"}
                    </span>{" "}
                    {game.line.rl.away.rate}
                  </div>

                  <div>
                    <span className="line-spread-label">
                      {game.line.p.away.da ? "(-2.5)" : "(+2.5)"}
                    </span>{" "}
                    {game.line.p.away.rate}
                  </div>

                  <div>{game.line.s.away}</div>
                  <div>{game.line.k.away}</div>
                </div>

                <div className="line-card-row">
                  <div className="line-team-number">{game.home.code}</div>

                  <div className="line-team-cell">
                    <img src={game.home.logo} alt={game.home.symbol} />

                    <div className="line-team-copy">
                      <span className="line-team-symbol">{game.home.symbol}</span>
                      <span className="line-team-record">{getTeamRecord(game.home)}</span>
                    </div>
                  </div>

                  <div>{game.line.jc.home}</div>
                  <div>-{game.line.jc.runs}</div>

                  <div>
                    <span className="line-spread-label">
                      {game.line.rl.home.da ? "(-1.5)" : "(+1.5)"}
                    </span>{" "}
                    {game.line.rl.home.rate}
                  </div>

                  <div>
                    <span className="line-spread-label">
                      {game.line.p.home.da ? "(-2.5)" : "(+2.5)"}
                    </span>{" "}
                    {game.line.p.home.rate}
                  </div>

                  <div>{game.line.s.home}</div>
                  <div>{game.line.k.home}</div>
                </div>

                <div className="line-pitcher-strip">
                  <div className="line-pitcher-side">
                    <img
                      src={game.picher.away.img || imageUrl}
                      alt={game.picher.away.name}
                    />

                    <div className="line-pitcher-content">
                      <div className="line-pitcher-name">
                        {splitSecondCapital(game.picher.away.name?.replace(/ /g, ""))}
                      </div>

                      <div className="line-pitcher-stats">
                        <div>
                          <span>W-L</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.away, "wins"))}-
                            {formatStat(getPitcherStat(game.picher.away, "loses"))}
                          </strong>
                        </div>

                        <div>
                          <span>IP</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.away, "ip"), 1)}
                          </strong>
                        </div>

                        <div>
                          <span>K</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.away, "so"))}
                          </strong>
                        </div>

                        <div>
                          <span>ERA</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.away, "era"), 2)}
                          </strong>
                        </div>

                        <div>
                          <span>WHIP</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.away, "whip"), 2)}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="line-vs">VS</div>

                  <div className="line-pitcher-side line-pitcher-side-home">
                    <img
                      src={game.picher.home.img || imageUrl}
                      alt={game.picher.home.name}
                    />

                    <div className="line-pitcher-content">
                      <div className="line-pitcher-name">
                        {splitSecondCapital(game.picher.home.name?.replace(/ /g, ""))}
                      </div>

                      <div className="line-pitcher-stats">
                        <div>
                          <span>W-L</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.home, "wins"))}-
                            {formatStat(getPitcherStat(game.picher.home, "loses"))}
                          </strong>
                        </div>

                        <div>
                          <span>IP</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.home, "ip"), 1)}
                          </strong>
                        </div>

                        <div>
                          <span>K</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.home, "so"))}
                          </strong>
                        </div>

                        <div>
                          <span>ERA</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.home, "era"), 2)}
                          </strong>
                        </div>

                        <div>
                          <span>WHIP</span>
                          <strong>
                            {formatStat(getPitcherStat(game.picher.home, "whip"), 2)}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="game-card div-16"><Publish /></div>
          </>) : games && games.games ? (
            <>
              {games.games.map((game, index) => (
                <div className="game-card live-game-card" key={index}>
                  <div className="scoreboard">
                    <table className="live-score-table">
                      <colgroup>
                        <col className="live-col-team" />
                        <col span="9" className="live-col-inning" />
                        <col span="3" className="live-col-final" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th></th>
                          {Array.from({ length: Math.max(9, game.innings.length) }, (_, i) => (
                            <th key={i} className="fix-inin">{i + 1}</th>
                          ))}
                          <th className="td-fix">R</th>
                          <th className="td-fix">H</th>
                          <th className="td-fix">E</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="team">
                            <div style={{ display: "flex", alignItems: "center", gap: "0.35vw", justifyContent: "center" }}>
                              <img src={game.away.logo} height={30} width={30} alt={game.away.symbol} />
                              <span>{game.away.symbol}</span>
                            </div>
                          </td>
                          {game.innings.map((inning, idx) => (
                            <td
                              key={idx}
                              className={inning && game.batting === "away" && game.inning === idx + 1 && !game.gameOver ? "batting" : ""}
                            >
                              {inning ? inning?.away : "-"}
                            </td>
                          ))}
                          <td className={game.score.away > game.score.home && !game.gameOver ? "win" : game.score.away > game.score.home && game.gameOver ? "winner" : ""}>
                            {game.score.away}
                          </td>
                          <td>{game.hits.away}</td>
                          <td>{game.err.away}</td>
                        </tr>

                        <tr>
                          <td className="team">
                            <div style={{ display: "flex", alignItems: "center", gap: "0.35vw", justifyContent: "center" }}>
                              <img src={game.home.logo} height={30} width={30} alt={game.home.symbol} />
                              <span>{game.home.symbol}</span>
                            </div>
                          </td>
                          {game.innings.map((inning, idx) => (
                            <td
                              key={idx}
                              className={inning && game.batting === "home" && game.inning === idx + 1 && !game.gameOver ? "batting" : ""}
                            >
                              {inning ? inning?.home : "-"}
                            </td>
                          ))}
                          <td className={game.score.away < game.score.home && !game.gameOver ? "win" : game.score.away < game.score.home && game.gameOver ? "winner" : ""}>
                            {game.score.home}
                          </td>
                          <td>{game.hits.home}</td>
                          <td>{game.err.home}</td>
                        </tr>
                      </tbody>
                    </table>

{game.gameOver ? (
  renderFinalPitchers(game)
) : (
  renderLivePlayers(game)
)}
                  </div>

                  <div className="bases-panel">
                    <span className="inning">
                      {game.inning}-{!game.gameOver ? (game.batting === "home" ? "BOT" : "TOP") : "Final"}
                    </span>

                    <div className="bases">
                      <div className={`base first ${game.bases[0] ? "occupied" : ""}`}></div>
                      <div className={`base second ${game.bases[1] ? "occupied" : ""}`}></div>
                      <div className={`base third ${game.bases[2] ? "occupied" : ""}`}></div>
                    </div>

                    <div className="balls-strikes">
                      <span className={`dot ${game.outs >= 1 ? "filled" : ""}`}></span>
                      <span className={`dot ${game.outs >= 2 ? "filled" : ""}`}></span>
                      <span className="dot"></span>
                    </div>

                    {game.gameOver ? (
                      <div className="div-hit"></div>
                    ) : (
                      <div
                        className={`div-hit ${game.result === "HR"
                          ? "bg-primary text-white"
                          : game.result === "Change"
                            ? "bg-warning text-danger"
                            : game.result === "2B" || game.result === "3B"
                              ? "bg-success text-white"
                              : game.result === "H"
                                ? "bg-danger text-white"
                                : "bg-dark"
                          }`}
                      >
                        {!game.gameOver && (game.result === "HR" || game.result === "2B" || game.result === "3B" || game.result === "H" || game.result === "BB" || game.result === "HP" || game.result === "FC") ? (
                          <div>
                            <div>
                              <span className="name-hit">
                                {splitSecondCapital(game.linup[game.batting][game.bat[game.batting] > 1 ? game.bat[game.batting] - 2 : 8].name?.replace(/ /g, ""))}
                              </span>
                            </div>
                            <div>
                              <span className="name">{game.result}</span>
                            </div>
                          </div>
                        ) : (
                          <span
                            className={`hit ${game.result === "HR"
                              ? "bg-primary text-white"
                              : game.result === "Change"
                                ? "bg-warning text-danger"
                                : game.result === "2B" || game.result === "3B"
                                  ? "bg-success text-white"
                                  : "bg-dark"
                              }`}
                          >
                            {!game.gameOver ? game.result : ""}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <div className="game-card div-16"><Publish /></div>
            </>
          ) : (
          <div className="init-logo">
            <img src={mlbLogo} />
            <div className="loading">LOADING......</div>
          </div>
        )}
        <div>
          <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header>
              <div className="text-dark fs-3">{gameSelected && `(${gameSelected.away.code})${gameSelected.away.symbol} VS (${gameSelected.home.code})${gameSelected.home.symbol}`}</div>
              <button className="btn btn-close"></button></Modal.Header>
            <Modal.Body>{
              <div>

                {gameSelected && <div className="col-12 row align-content-center">
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}R`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}R`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}P`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}P`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}+`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}+`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}R`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}R`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}P`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}P`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}-`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}-`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}K+`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}K+`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}K-`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}K-`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}S+`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}S+`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.away.code}S-`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.away.code}S-`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}K+`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}K+`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}K-`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}K-`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}S+`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}S+`}</div>
                  <div className="col-3 btn fs-4" onClick={() => { handleGetBet(`${gameSelected.home.code}S-`, betted, programs, amountBetRef.current.value || '50'); handleGetAmountWin(amountBetRef.current.value) }}>{`${gameSelected.home.code}S-`}</div>
                </div>}
                <div>
                  <div className="col-12 table-responsive mt-1">
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Apuesta</th>
                          <th>Linea</th>
                          <th>Borrar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {betted.length > 0 ? (
                          betted.map((item, index) => (
                            <tr key={index}>
                              <td>{item.number}</td>
                              <td>{item.betted}</td>
                              <td>{item.rate}</td>
                              <td>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => Retirar(index)}>
                                  x
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr></tr>
                        )}
                      </tbody>
                    </table>
                    <div className="col-12 row mb-3 justify-content-end mr-0 pr-0">
                      <div className="col-6">
                        <label htmlFor="" className="label fs-4 text-dark">
                          Credito:
                        </label>
                      </div>
                      <div className="col-6">
                        <label htmlFor="" className="label fs-4 text-dark">
                          {parseFloat(credit || 0).toLocaleString('en-EN', { maximumFractionDigits: 2 })}
                        </label>
                      </div>
                      <div className="col-6">
                        <label htmlFor="" className="label fs-4 text-dark">
                          Gana:
                        </label>
                      </div>
                      <div className="col-6">
                        <label htmlFor="" className="label fs-4 text-dark">
                          {parseFloat(amountWin || 0).toLocaleString('en-EN', { maximumFractionDigits: 2 })}
                        </label>
                      </div>
                      <div className="col-6 mr-0 pr-0 justify-content-end">
                        <label htmlFor="" className="label fs-4 text-dark">
                          Apostado
                        </label>
                      </div>
                      <div className="col-6 mr-0 pr-0">
                        <input type="number" className="form-control" ref={amountBetRef} onChange={() => handleGetAmountWin(amountBetRef.current.value)} />
                      </div>
                    </div>
                  </div>

                </div>
              </div>}</Modal.Body>
            <Modal.Footer>
              <div className="col-12 row mb-3 mr-0 pr-0">
                <div className="col-6">
                  {" "}
                  <button type="button" className="btn btn-warning form-control" onClick={CancelarThisBet}>
                    {" "}
                    Cancelar
                  </button>
                </div>
                <div className="col-6">
                  {" "}
                  <button type="button" className="btn btn-primary form-control" onClick={CreateTicket}>
                    Crear
                  </button>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
      <footer className="">
        <Footer games={results} event={games?.num} jpg={jpg} jpl={jpl} jpc={jpc} />
      </footer>
    </div>
  );
}
export default Lines;
